import { render, staticRenderFns } from "./serviceDetail.vue?vue&type=template&id=b7f411e0&scoped=true"
import script from "./serviceDetail.vue?vue&type=script&lang=js"
export * from "./serviceDetail.vue?vue&type=script&lang=js"
import style0 from "./serviceDetail.vue?vue&type=style&index=0&id=b7f411e0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7f411e0",
  null
  
)

export default component.exports